import axios from "./axios";
import { userData } from "./Currentuserdata";

export default {
    /**
     * Get all printers for a business
     * @api {GET} /printers
     */
    getPrinters() {
        const user = userData();
        const options = {
            method: 'GET',
            url: `/printers?ID_Business=${user.businessid}&ID_Branch=${user.branch}`,
            headers: {'content-type': 'application/json'},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Add Printer
     * @api {POST} /printers
     */
    addPrinter: function(data) {
        const user = userData();
        const options = {
            method: 'POST',
            url: '/printers',
            headers: {'content-type': 'application/json'},
            data: {
                ...data,
                ID_Business: user.businessid,
                ID_Branch: user.branch
            }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Update Printer
     * @api {PUT} /printers/:id
     */
    updatePrinter: function(id, data) {
        const user = userData();
        const options = {
            method: 'PUT',
            url: `/printers/${id}`,
            headers: {'content-type': 'application/json'},
            data: {
                ...data,
                ID_Business: user.businessid,
                ID_Branch: user.branch
            }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Delete Printer (soft delete)
     * @api {DELETE} /printers/:id
     */
    deletePrinter: function(id) {
        const user = userData();
        const options = {
            method: 'DELETE',
            url: `/printers/${id}`,
            headers: {'content-type': 'application/json'},
            data: {
                ID_Branch: user.branch,
                ID_Business: user.businessid
            }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Get all printer types
     * @api {GET} /printer-types
     */
    getPrinterTypes: function() {
        const user = userData();
        const options = {
            method: 'GET',
            url: `/printer-types?ID_Business=${user.businessid}&ID_Branch=${user.branch}`,
            headers: {'content-type': 'application/json'},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Add Printer Type
     * @api {POST} /printer-types
     */
    addPrinterType: function(data) {
        const user = userData();
        const options = {
            method: 'POST',
            url: '/printer-types',
            headers: {'content-type': 'application/json'},
            data: {
                ...data,
                ID_Business: user.businessid,
                ID_Branch: user.branch
            }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Update Printer Type
     * @api {PUT} /printer-types/:id
     */
    updatePrinterType: function(id, data) {
        const user = userData();
        const options = {
            method: 'PUT',
            url: `/printer-types/${id}`,
            headers: {'content-type': 'application/json'},
            data: {
                ...data,
                ID_Business: user.businessid,
                ID_Branch: user.branch
            }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Delete Printer Type (soft delete)
     * @api {DELETE} /printer-types/:id
     */
    deletePrinterType: function(id) {
        const user = userData();
        const options = {
            method: 'DELETE',
            url: `/printer-types/${id}`,
            headers: {'content-type': 'application/json'},
            data: {
                ID_Business: user.businessid,
                ID_Branch: user.branch
            }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Print a ticket using the print server
     * @api {POST} /printers/print-ticket
     */
    printTicket: function(data) {
        const options = {
            method: 'POST',
            url: '/printers/print-ticket',
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
}